import { faqs } from "@/config/content";
import { Reveal } from "@/lib/motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const Faq = () => (
  <section className="py-20 lg:py-28 bg-white" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark mb-4">Häufige Fragen</p>
        <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-charcoal leading-[1.15]">
          Antworten auf häufige Fragen
        </h2>
      </Reveal>
      <Reveal delay={0.05}>
        <Accordion type="single" collapsible className="mt-10 w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-b border-border">
              <AccordionTrigger className="text-left font-heading font-semibold text-charcoal text-lg hover:no-underline hover:text-forest py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-charcoal-muted text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
